<template>
  <b-container variant='light'>
    <b-container class="col-xs-12 col-sm-12 col-md-9 col-xl-6">
        <b-list-group-item variant="info">
            <h3>Votre réponse</h3>
            <draggable v-model="userAnswers" class="drop-zone" v-bind="dragOptions" @start="drag=true" @end="drag=false">
                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <b-list-group-item variant="primary" class="draggable" v-for="(answer, index) in userAnswers" :key="index">{{answer}}</b-list-group-item>
                </transition-group>
            </draggable>       
        </b-list-group-item>   
    </b-container>
  </b-container>
</template>

<script>
import draggable from 'vuedraggable'
export default {
    data () {
        return {
            userAnswers : [],
            drag: false
        }
    },
    computed: {
        selected () {
            if (this.userAnswers.length >= 1) {
                let selected = ''
                this.userAnswers.forEach((el, index) => {
                    selected += el
                    if(index+1 < this.userAnswers.length) {
                        selected += '; '
                    }
                })
                return selected
            }
            else {return null}
        },
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            }
        }
    },
    components: {
        draggable,
    },
    props: {
        question: Object,
    },
  watch: {
    selected: function() {
        this.$emit('update-selected', this.selected)
    },
    question: function() {
        this.userAnswers = this.question.answers[0].answer_value.split('; ').sort(()=> Math.random() - 0.5)
    }
  },
  mounted() {
    this.userAnswers = this.question.answers[0].answer_value.split('; ').sort(()=> Math.random() - 0.5)
  },
}
</script>

<style scoped>
h3 {
    width: 100%;
    border-bottom: 1px solid
}
.draggable, .draggable:hover {
    cursor: grab;
}
.drop-zone {
    min-height: 30px;
}
.list-group-item {
    padding-left: 10px;
    padding-right: 10px;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

</style>